export const accordionData = 
[
  {
    "profile": "Business Development Associate (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Drive lead generation efforts for app development, website development, Wordpress, ecommerce, and digital marketing services.",
          "Utilize platforms like freelance, LinkedIn, Upwork, and Fiverr to prospect and generate leads.",
          "Conduct market research to identify target industries, key decision-makers, and emerging trends.",
          "Build and nurture relationships with potential clients, understanding their specific requirements and pain points.",
          "Prepare and deliver compelling presentations and proposals to showcase the company's expertise and capabilities.",
          "Actively engage in networking events, conferences, and industry forums to expand the company's reach and generate leads.",
          "Stay updated on the latest trends and advancements in app development, website development, Wordpress, ecommerce, and digital marketing.",
          "Negotiate contracts, pricing, and terms with clients to close deals and achieve sales targets.",
          "Maintain accurate records of leads, sales activities, and client interactions.",
          "Provide regular updates and reports on sales activities, pipeline status, and business development progress."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Strong knowledge of app development, website development, Wordpress, ecommerce, and digital marketing.",
          "Proficiency in using freelance platforms, LinkedIn, Upwork, and Fiverr for lead generation.",
          "Excellent communication, negotiation, and presentation skills.",
          "Results-oriented mindset with a focus on meeting and exceeding sales targets.",
          "Ability to work independently, as well as collaboratively with a team.",
          "Skills Required: MS Office and Google Workspace, search engine optimization (SEO), social media marketing, email marketing, and online advertising, familiarity with customer relationship management (CRM) systems, sales automation tools."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Business Analyst (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and stakeholders to understand their business objectives, requirements, and challenges.",
          "Conduct analysis of business processes, systems, and strategies to identify areas for improvement and growth.",
          "Gather and document detailed business requirements.",
          "Conduct research and analysis of market trends, industry best practices, and emerging technologies related to app development, website development, Wordpress, ecommerce, and digital marketing.",
          "Analyze data and metrics to provide insights and recommendations for optimizing business operations and performance.",
          "Work closely with technical teams to translate business requirements into technical specifications and ensure alignment between business goals and solution design.",
          "Develop and maintain project documentation, including functional and technical specifications, process flow diagrams, and system documentation."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Strong knowledge of app development, website development, Wordpress, ecommerce, and digital marketing concepts.",
          "Excellent analytical, problem-solving, and critical thinking skills.",
          "Proficiency in requirements gathering and documentation techniques.",
          "Strong communication and interpersonal skills to effectively collaborate with stakeholders.",
          "Ability to prioritize and manage multiple tasks and projects simultaneously.",
          "Familiarity with project management methodologies and tools.",
          "Skills Required: MS Office and Google Workspace, various software applications and tools used in business analysis, such as requirements management tools, diagramming tools, and data modeling software."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Business Development Associate (Intern) - Alternate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Identify and qualify potential clients through cold calling, email campaigns, and targeted outreach.",
          "Drive lead generation efforts for app development, website development, Wordpress, ecommerce, and digital marketing services.",
          "Conduct competitor analysis to understand the market landscape and identify unique selling points for our services.",
          "Attend industry events and tradeshows to build brand awareness and establish relationships with key industry players.",
          "Collaborate with the delivery team to ensure a smooth transition from sales to project initiation, maintaining strong communication throughout the process.",
          "Continuously expand knowledge of industry trends and emerging technologies, staying ahead of the curve and positioning the company as an industry leader.",
          "Build and nurture a strong network of industry contacts, including potential partners and influencers, to leverage for business development opportunities.",
          "Analyze and report on sales data, market trends, and client feedback to identify areas for improvement and optimize business development strategies.",
          "Collaborate with cross-functional teams to develop innovative service offerings and solutions to meet evolving client needs.",
          "Provide input and support in the development of marketing strategies, campaigns, and promotional activities to drive lead generation."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Strong knowledge of app development, website development, Wordpress, ecommerce, and digital marketing.",
          "Proficiency in using freelance platforms, LinkedIn, Upwork, and Fiverr for lead generation.",
          "Excellent communication, negotiation, and presentation skills.",
          "Results-oriented mindset with a focus on meeting and exceeding sales targets.",
          "Ability to work independently, as well as collaboratively with a team.",
          "Skills Required: MS Office and Google Workspace, search engine optimization (SEO), social media marketing, email marketing, and online advertising, familiarity with customer relationship management (CRM) systems, sales automation tools."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Business Analyst (Intern) - Alternate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Handling and generating online leads from different platforms (Upwork, LinkedIn, PPH etc).",
          "Understand Client’s Business and capture the appropriate requirements.",
          "Provide the functional and technical support to the requirement team and the development team.",
          "Possess good functional knowledge of Business Processes.",
          "Understand Client’s Business and provide Solutions pertaining to their business needs.",
          "Interact with the Clients and Technical Team, via Con-calls & Client meetings, and be accountable for the Project Delivery & Timelines.",
          "Writing User Stories, Acceptance Criteria, Project Plans.",
          "Make informed decisions, develop business plans and implement new strategies.",
          "Develop proposals, design frameworks and provide solutions.",
          "Developing reports for several ongoing projects to identify cost-saving opportunities and areas for improvement."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Strong knowledge of app development, website development, Wordpress, ecommerce, and digital marketing concepts.",
          "Excellent analytical, problem-solving, and critical thinking skills.",
          "Proficiency in requirements gathering and documentation techniques.",
          "Strong communication and interpersonal skills to effectively collaborate with stakeholders.",
          "Ability to prioritize and manage multiple tasks and projects simultaneously.",
          "Familiarity with project management methodologies and tools.",
          "Skills Required: MS Office and Google Workspace, various software applications and tools used in business analysis, such as requirements management tools, diagramming tools, and data modeling software."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "MERN (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Develop and design front end web architecture.",
          "Build interactive consumer data from multiple systems.",
          "Define code architecture decisions to support high-performance products.",
          "Translate wireframes and PSD Designs into functional web applications.",
          "Work with development teams and managers to ideate software solutions.",
          "Develop well-functioning databases and applications.",
          "Conduct and participate in project planning & scheduling and design discussions.",
          "Test software to ensure efficiency.",
          "Address and improve any technical issues."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "In-depth knowledge of NodeJS, ExpressJS or Restify.",
          "Should have proper understanding of MongoDB, Express.js, React.js, Node.js.",
          "Ability to bind UI elements to JavaScript object models.",
          "Experience creating RESTful services with Node.js.",
          "Proficiency in OOP and database concepts.",
          "Proven experience in front & back-end development.",
          "Ability to create front end applications using HTML5, Angular, LESS/SASS.",
          "Knowledge of modern frameworks and design patterns.",
          "Ability to create Unit and Integration tests to ensure the quality of code.",
          "Strong problem-solving skills.",
          "Good communication skills.",
          "Strong analytical thinking."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "React (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Coordinate with the development team to discuss user interface ideas and applications.",
          "Review application requirements and interface designs.",
          "Identify web-based user interactions.",
          "Develop and implement highly responsive user interface components using react concepts.",
          "Write application interface codes using JavaScript following react.js workflows.",
          "Troubleshoot interface software and debug application codes.",
          "Develop and implement front-end architecture to support user interface concepts.",
          "Monitor and improve front-end performance.",
          "Document application changes and develop updates."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Previous experience working as a react.js developer.",
          "In-depth knowledge of JavaScript, CSS, HTML, and front-end languages.",
          "Knowledge of REACT tools including React.js, Webpack, Enzyme, Redux, and Flux.",
          "Experience with user interface design.",
          "Knowledge of performance testing frameworks including Mocha and Jest.",
          "Experience with browser-based debugging and performance testing software.",
          "Excellent troubleshooting skills.",
          "Good project management skills."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Wordpress Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and objectives.",
          "Assist in the development and customization of WordPress themes and plugins, following best practices and coding standards.",
          "Implement responsive web design principles to ensure websites are optimized for various devices and screen sizes.",
          "Conduct quality assurance and testing to identify and fix bugs or issues in WordPress websites.",
          "Support the integration of third-party APIs, services, and plugins into WordPress websites.",
          "Assist in troubleshooting and resolving technical issues related to WordPress websites.",
          "Stay updated with the latest trends and developments in WordPress and web development.",
          "Assist in the documentation of project requirements, processes, and workflows.",
          "Collaborate with team members to improve development processes and enhance website performance.",
          "Provide support to the development team in various tasks and projects as assigned."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in Computer Science, Software Engineering, or a related field.",
          "Basic knowledge of HTML, CSS, JavaScript, and PHP.",
          "Familiarity with WordPress and its core functionalities.",
          "Eagerness to learn and explore new technologies and concepts in web development.",
          "Strong problem-solving skills and attention to detail.",
          "Good communication and collaboration skills.",
          "Ability to work well within a team and take direction from senior developers."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Wordpress Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients, project managers, and cross-functional teams to understand project requirements, objectives, and timelines.",
          "Design and develop custom WordPress themes and plugins, ensuring clean, efficient, and scalable code.",
          "Customize and extend existing WordPress themes and plugins to meet specific project needs.",
          "Implement responsive web design principles to create websites that are optimized for various devices and screen sizes.",
          "Ensure the security, performance, and scalability of WordPress websites through proper optimization techniques and best practices.",
          "Troubleshoot and debug complex technical issues related to WordPress websites and provide effective solutions.",
          "Conduct thorough testing and quality assurance to identify and address any bugs or issues prior to deployment.",
          "Integrate WordPress websites with third-party APIs, services, and plugins as required.",
          "Stay up-to-date with the latest trends, tools, and techniques in WordPress development, and share knowledge with the team.",
          "Provide technical guidance, support, and mentorship to junior developers as needed.",
          "Collaborate with the development team to continuously improve processes, workflows, and development standards."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum Work experience: 2 years.",
          "In-depth knowledge of WordPress architecture, including theme and plugin development, custom post types, and advanced functionality.",
          "Proficiency in front-end web technologies, such as HTML5, CSS3, JavaScript (including ES6+), and jQuery.",
          "Strong understanding of PHP and MySQL, and experience with custom database queries and optimization.",
          "Experience with version control systems, particularly Git.",
          "Familiarity with performance optimization techniques, caching mechanisms, and security best practices.",
          "Solid understanding of responsive web design principles and mobile-first development.",
          "Ability to write clean, efficient, and well-documented code, following coding standards and best practices.",
          "Excellent problem-solving and debugging skills, with a keen attention to detail.",
          "Ability to handle multiple projects and priorities simultaneously, while meeting deadlines.",
          "Bachelor's degree in Computer Science, Engineering, or a related field (preferred)."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Digital Marketer Expert (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Support the development and execution of digital marketing campaigns across multiple channels.",
          "Assist in creating engaging content for social media, emails, and websites.",
          "Conduct market research and competitive analysis to identify trends and opportunities.",
          "Monitor and analyze campaign performance metrics to provide insights and recommendations.",
          "Collaborate with the team to optimize website content for search engine visibility.",
          "Assist in managing social media accounts and engaging with online communities.",
          "Help in creating and managing email marketing campaigns.",
          "Stay updated with digital marketing trends and industry best practices.",
          "Support the team in various marketing projects and tasks as assigned."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Currently pursuing a degree in Marketing, Digital Marketing, Communications, or a related field.",
          "Basic understanding of digital marketing concepts and strategies.",
          "Familiarity with social media platforms and email marketing tools.",
          "Strong written and verbal communication skills.",
          "Detail-oriented with good organizational skills.",
          "Self-motivated and eager to learn.",
          "Ability to work collaboratively in a team environment.",
          "Prior experience or coursework in digital marketing (preferred, but not required)."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Digital Marketer Expert (Associate)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Develop and implement digital marketing strategies to meet company and client objectives, including lead generation, brand awareness, and customer acquisition.",
          "Conduct thorough market research and competitive analysis to identify target audiences, industry trends, and growth opportunities.",
          "Create and manage comprehensive digital marketing campaigns across various channels, such as SEO, PPC, social media, email marketing, and content marketing.",
          "Utilize analytics tools to track, measure, and analyze campaign performance, providing actionable insights and recommendations for optimization.",
          "Optimize website content and landing pages for search engine visibility, user experience, and conversion rate optimization.",
          "Plan and execute social media strategies, managing social media accounts, and driving engagement and growth.",
          "Develop and oversee email marketing campaigns, including segmentation, content creation, automation, and performance analysis.",
          "Collaborate with internal teams and external partners to create compelling content, graphics, videos, and other digital assets.",
          "Stay updated with industry trends, emerging technologies, and digital marketing best practices, continuously identifying new opportunities for growth and improvement.",
          "Provide strategic guidance and mentorship to junior team members, fostering their professional growth and development.",
          "Monitor industry trends, competitors, and customer feedback to identify new opportunities and make recommendations for business growth."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in Marketing, Digital Marketing, Communications, or a related field (preferred).",
          "Minimum Work experience: 2 years.",
          "Deep understanding of digital marketing channels, including SEO, PPC, social media, email marketing, content marketing, and analytics.",
          "Strong analytical skills and the ability to interpret data, analyze trends, and provide actionable insights.",
          "Experience with marketing automation tools, CRM systems, and analytics platforms.",
          "In-depth knowledge of search engine optimization (SEO) best practices and strategies.",
          "Proficiency in utilizing social media platforms and managing social media campaigns.",
          "Excellent written and verbal communication skills, with the ability to create compelling content and effectively communicate marketing messages.",
          "Proven experience in managing multiple projects and priorities simultaneously, meeting deadlines, and delivering results.",
          "Creative thinker with a keen eye for detail, staying up-to-date with the latest industry trends and emerging technologies.",
          "Strong leadership and mentoring abilities, with a collaborative and team-oriented mindset."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Backend Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and objectives.",
          "Assist in the design, development, and maintenance of backend systems and APIs.",
          "Write clean, efficient, and well-documented code following best practices and coding standards.",
          "Participate in code reviews to ensure code quality and adherence to guidelines.",
          "Troubleshoot and debug issues in backend systems, and provide timely resolutions.",
          "Assist in integrating third-party services and APIs into backend systems.",
          "Assist in optimizing backend systems for performance, scalability, and security.",
          "Stay updated with the latest technologies and trends in backend development.",
          "Support the development team in various tasks and projects as assigned."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Currently pursuing a degree in Computer Science, Software Engineering, or a related field.",
          "Basic knowledge of backend development concepts and programming languages such as Python, Java, or Node.js.",
          "Familiarity with RESTful APIs and database management systems (e.g., MySQL, PostgreSQL).",
          "Understanding of version control systems, such as Git.",
          "Strong problem-solving skills and attention to detail.",
          "Good communication and collaboration skills.",
          "Eagerness to learn and explore new technologies and concepts in backend development."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Backend Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients, project managers, and cross-functional teams to gather and understand project requirements and objectives.",
          "Design, develop, and maintain backend systems and APIs using appropriate programming languages and frameworks.",
          "Write clean, efficient, and reusable code following best practices and coding standards.",
          "Ensure the performance, scalability, and security of backend systems through optimization and proper implementation.",
          "Perform thorough testing and debugging of backend code to identify and resolve issues promptly.",
          "Integrate third-party services and APIs into backend systems, ensuring seamless functionality.",
          "Develop and maintain databases, ensuring efficient data storage and retrieval.",
          "Conduct code reviews and provide constructive feedback to maintain code quality and consistency.",
          "Stay updated with the latest trends and advancements in backend development and propose innovative solutions to enhance software architecture and performance.",
          "Collaborate with frontend developers, designers, and other team members to ensure smooth integration and implementation of software solutions.",
          "Mentor and provide guidance to junior developers, fostering their professional growth and skill development."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in Computer Science, Software Engineering, or a related field (preferred).",
          "Minimum work experience: 2 years.",
          "Strong proficiency in backend programming languages such as Python, Java, or Node.js.",
          "Extensive experience with backend frameworks and technologies, such as Django, Flask, Spring, or Express.js.",
          "In-depth knowledge of relational and/or NoSQL databases and their query languages (e.g., MySQL, PostgreSQL, MongoDB).",
          "Familiarity with RESTful APIs, microservices architecture, and API design principles.",
          "Experience with version control systems, such as Git.",
          "Strong problem-solving and analytical skills, with attention to detail.",
          "Excellent communication and collaboration abilities, working effectively within cross-functional teams.",
          "Ability to prioritize and manage multiple projects while meeting deadlines.",
          "Demonstrated ability to lead and mentor junior developers (preferred).",
          "Strong understanding of software development lifecycle and Agile methodologies."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Kotlin Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into Kotlin-based solutions.",
          "Assist in the design, development, and testing of high-quality software applications using Kotlin and relevant technologies.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Debug and troubleshoot issues, identify root causes, and implement effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest Kotlin trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Solid understanding of object-oriented programming principles and concepts.",
          "Proficiency in Kotlin programming language or strong experience in Java with a willingness to learn Kotlin.",
          "Familiarity with mobile or web development frameworks and technologies.",
          "Basic understanding of software development lifecycle (SDLC) and agile methodologies.",
          "Strong problem-solving skills and attention to detail.",
          "Good verbal and written communication skills.",
          "Ability to work effectively in a team environment and collaborate with colleagues."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Kotlin Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable software solutions.",
          "Develop robust and high-performance applications using Kotlin and relevant technologies.",
          "Write clean, maintainable, and testable code following best practices and coding standards.",
          "Implement and maintain unit tests and integration tests to ensure software quality.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Debug and resolve complex technical issues, identifying root causes and implementing effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to integrate frontend applications seamlessly.",
          "Stay updated with the latest Kotlin trends, libraries, and best practices, and contribute to the continuous improvement of development processes.",
          "Assist in estimating project timelines and deliverables, ensuring timely and high-quality delivery.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Minimum 2 years of experience in Kotlin development, with a strong understanding of object-oriented programming principles and concepts.",
          "Solid knowledge of mobile or web development frameworks and technologies.",
          "Experience in designing and developing efficient, scalable, and secure software solutions.",
          "Strong understanding of software development lifecycle (SDLC) and agile methodologies.",
          "Familiarity with version control systems, such as Git.",
          "Excellent problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Experience with additional programming languages and technologies is a plus.",
          "Prior experience working in an IT consulting or software development company is preferred."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Android Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into Android app features and functionality.",
          "Assist in the design, development, and testing of high-quality Android applications using Java or Kotlin and relevant technologies.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Debug and troubleshoot issues, identify root causes, and implement effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest Android development trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Solid understanding of object-oriented programming principles and concepts.",
          "Experience with Java or Kotlin programming language.",
          "Familiarity with Android SDK, Android Studio, and development tools.",
          "Basic understanding of mobile app development lifecycle.",
          "Strong problem-solving skills and attention to detail.",
          "Good verbal and written communication skills.",
          "Ability to work effectively in a team environment and collaborate with colleagues."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Android Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable Android application solutions.",
          "Develop robust and user-friendly Android applications using Java or Kotlin and relevant technologies.",
          "Write clean, maintainable, and testable code following best practices and coding standards.",
          "Implement and maintain unit tests and integration tests to ensure software quality.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Debug and resolve complex technical issues, identifying root causes and implementing effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to integrate frontend applications seamlessly.",
          "Stay updated with the latest Android development trends, libraries, and best practices, and contribute to the continuous improvement of development processes.",
          "Assist in estimating project timelines and deliverables, ensuring timely and high-quality delivery.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years experience in an IT consulting or software development company is preferred.",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proven experience in Android application development, with a strong understanding of Java or Kotlin and Android SDK.",
          "Experience with mobile app development frameworks and libraries.",
          "Solid knowledge of software development lifecycle (SDLC) and agile methodologies.",
          "Familiarity with version control systems, such as Git.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Experience with additional programming languages and technologies is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "UI Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into visually appealing and user-friendly web interfaces.",
          "Assist in the design and development of responsive and interactive user interfaces using HTML, CSS, and JavaScript.",
          "Implement UI designs using front-end frameworks and libraries, ensuring cross-browser compatibility and optimal performance.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest UI/UX trends, techniques, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Strong understanding of HTML, CSS, and JavaScript.",
          "Familiarity with front-end frameworks and libraries (e.g., React, Angular, Vue.js) is a plus.",
          "Basic knowledge of UI/UX principles and design tools (e.g., Adobe XD, Sketch).",
          "Experience with responsive design and mobile-first development.",
          "Strong problem-solving skills and attention to detail.",
          "Good verbal and written communication skills.",
          "Ability to work effectively in a team environment and collaborate with colleagues."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "UI Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and translate them into visually engaging and functional web interfaces.",
          "Design and develop responsive and interactive user interfaces using HTML, CSS, and JavaScript.",
          "Implement UI designs using front-end frameworks and libraries, ensuring cross-browser compatibility and optimal performance.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Collaborate with cross-functional teams, including designers, UI/UX specialists, and backend developers, to ensure seamless integration and functionality.",
          "Stay updated with the latest UI/UX trends, techniques, and best practices, and contribute to the continuous improvement of development processes.",
          "Assist in estimating project timelines and deliverables, ensuring timely and high-quality delivery.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years experience in an IT consulting or software development company is preferred.",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proven experience in UI development, with a strong understanding of HTML, CSS, and JavaScript.",
          "Proficiency in front-end frameworks and libraries (e.g., React, Angular, Vue.js).",
          "Familiarity with UI/UX principles and design tools (e.g., Adobe XD, Sketch).",
          "Experience with responsive design and mobile-first development.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Experience with version control systems, such as Git, is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "UX Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team and UX designers to understand project requirements and translate them into intuitive and engaging user interfaces.",
          "Assist in the design and development of wireframes, prototypes, and mockups using industry-standard tools (e.g., Sketch, Adobe XD, Figma).",
          "Implement user-centered design principles and best practices to create user interfaces that are both visually appealing and functional.",
          "Write clean, efficient, and maintainable code using HTML, CSS, and JavaScript to bring designs to life.",
          "Conduct user research, usability testing, and analyze user feedback to iteratively improve the user experience.",
          "Participate in UX workshops, design reviews, and brainstorming sessions."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, human-computer interaction, design, or a related field.",
          "Strong understanding of user-centered design principles and methodologies.",
          "Familiarity with wireframing, prototyping, and design tools (e.g., Sketch, Adobe XD, Figma).",
          "Proficiency in HTML, CSS, and JavaScript for UI implementation.",
          "Knowledge of responsive design and mobile-first development.",
          "Strong problem-solving skills and attention to detail.",
          "Good verbal and written communication skills.",
          "Ability to work effectively in a team environment and collaborate with colleagues."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "UX Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and translate them into intuitive and engaging user interfaces.",
          "Design and develop wireframes, prototypes, and mockups using industry-standard tools (e.g., Sketch, Adobe XD, Figma).",
          "Implement user-centered design principles and best practices to create user interfaces that are visually appealing and highly functional.",
          "Write clean, efficient, and maintainable code using HTML, CSS, and JavaScript to bring designs to life.",
          "Conduct user research, usability testing, and analyze user feedback to inform design decisions and improve the user experience.",
          "Participate in UX workshops, design reviews, and brainstorming sessions.",
          "Collaborate with cross-functional teams, including designers, developers, and stakeholders, to ensure seamless integration of UX design and development.",
          "Stay up-to-date with the latest UX trends, techniques, and best practices.",
          "Mentor junior team members and provide guidance on UX design and development principles.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "2 years experience in an IT consulting or software development company is preferred.",
          "Bachelor's degree in computer science, human-computer interaction, design, or a related field (or equivalent work experience).",
          "Proven experience in UX design and development, with a strong portfolio showcasing successful UX projects.",
          "Strong understanding of user-centered design principles and methodologies.",
          "Proficiency in wireframing, prototyping, and design tools (e.g., Sketch, Adobe XD, Figma).",
          "Solid knowledge of HTML, CSS, and JavaScript for UI implementation.",
          "Experience with responsive design and mobile-first development.",
          "Familiarity with user research techniques and usability testing methodologies.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Experience with version control systems, such as Git, is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Graphics Designer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the design team to understand project requirements and translate them into visually appealing and user-centric designs.",
          "Assist in creating engaging designs for websites, mobile applications, social media, branding materials, and other marketing collaterals.",
          "Develop illustrations, icons, infographics, and other graphical elements to enhance visual communication.",
          "Work closely with developers and other stakeholders to ensure design feasibility and consistency across different platforms.",
          "Utilize graphic design software and tools, such as Adobe Creative Suite (Photoshop, Illustrator, InDesign), to create high-quality designs.",
          "Incorporate feedback and iterate on designs based on client or stakeholder input."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in graphic design, visual communication, or a related field.",
          "Proficiency in graphic design software such as Adobe Creative Suite (Photoshop, Illustrator, InDesign).",
          "Strong understanding of design principles, typography, and color theory.",
          "Creative thinking and ability to translate concepts into visually appealing designs.",
          "Attention to detail and a passion for creating high-quality visuals.",
          "Strong time management skills and ability to work on multiple projects simultaneously.",
          "Ability to take feedback constructively and iterate on designs.",
          "Familiarity with UI/UX design principles and responsive design is a plus.",
          "Basic understanding of IT concepts and the ability to align designs with technological considerations."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Graphics Designer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and translate them into visually appealing designs.",
          "Create engaging designs for websites, mobile applications, social media, branding materials, and other marketing collaterals.",
          "Develop illustrations, icons, infographics, and other graphical elements to enhance visual communication.",
          "Utilize graphic design software and tools, such as Adobe Creative Suite (Photoshop, Illustrator, InDesign), to create high-quality designs.",
          "Apply design principles, typography, and color theory to deliver visually appealing and effective designs.",
          "Incorporate feedback from clients, project stakeholders, and team members to refine and improve designs.",
          "Work closely with developers and other stakeholders to ensure design feasibility and effective implementation.",
          "Stay updated with the latest design trends, techniques, and best practices.",
          "Contribute to the continuous improvement of design processes and workflows within the IT consulting context.",
          "Mentor and provide guidance to junior team members, helping them enhance their design skills."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "2 years of experience working in an IT consulting or software development company is preferred.",
          "Bachelor's degree in graphic design, visual communication, or a related field (or equivalent work experience).",
          "Proven experience in graphic design, with a strong portfolio showcasing successful design projects.",
          "Proficiency in graphic design software such as Adobe Creative Suite (Photoshop, Illustrator, InDesign).",
          "Strong understanding of design principles, typography, and color theory.",
          "Creative thinking and ability to translate concepts into visually appealing designs.",
          "Attention to detail and a passion for creating high-quality visuals.",
          "Ability to work on multiple projects simultaneously and meet deadlines.",
          "Strong communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Familiarity with UI/UX design principles and responsive design is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Database Engineer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Assist in database design, development, and implementation for various projects.",
          "Participate in database modeling, normalization, and optimization activities.",
          "Assist in writing and optimizing SQL queries for efficient data retrieval and manipulation.",
          "Contribute to the design and implementation of database security and access controls.",
          "Assist in database performance tuning and optimization.",
          "Collaborate with the development team to ensure seamless integration of the database with applications.",
          "Contribute to data migration, backup, and recovery processes.",
          "Assist in monitoring and troubleshooting database issues.",
          "Stay up-to-date with the latest database technologies and trends."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, information systems, or a related field.",
          "Basic understanding of database concepts, including SQL, relational database management systems (RDBMS), and database design principles.",
          "Familiarity with SQL and query optimization techniques.",
          "Strong problem-solving and analytical skills.",
          "Good understanding of software development principles.",
          "Effective communication and teamwork abilities.",
          "Ability to learn and adapt quickly to new technologies and tools."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Database Engineer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand database requirements and design efficient and scalable database solutions.",
          "Develop and implement database models, schema, and designs for various projects.",
          "Optimize and fine-tune database performance, including query optimization and indexing strategies.",
          "Implement and maintain database security and access controls.",
          "Manage database backups, recovery processes, and disaster recovery plans.",
          "Monitor and troubleshoot database issues, identify root causes, and implement effective solutions.",
          "Collaborate with developers to ensure seamless integration of applications with the database.",
          "Conduct performance tuning, capacity planning, and scalability assessments for database systems.",
          "Stay up-to-date with the latest database technologies, trends, and best practices.",
          "Contribute to the continuous improvement of database engineering processes and methodologies."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Database Engineer or similar role, with a strong understanding of database management and administration.",
          "Bachelor's degree in computer science, information systems, or a related field (or equivalent work experience).",
          "Solid knowledge of SQL and relational database management systems (RDBMS).",
          "Proficiency in database design, normalization, and optimization.",
          "Experience with query optimization, indexing strategies, and performance tuning.",
          "Familiarity with database security and access control principles.",
          "Strong problem-solving and analytical skills.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Experience with database backup and recovery processes."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Network Engineer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Assist in network infrastructure design and implementation for various projects.",
          "Participate in network equipment configuration and troubleshooting.",
          "Assist in monitoring and optimizing network performance and availability.",
          "Collaborate with the team to implement and maintain network security measures.",
          "Support network documentation and reporting activities.",
          "Assist in diagnosing and resolving network issues.",
          "Stay up-to-date with the latest networking technologies and trends.",
          "Contribute to the continuous improvement of network engineering processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, information systems, or a related field.",
          "Basic understanding of networking concepts and protocols (TCP/IP, DNS, DHCP, routing, switching, etc.).",
          "Familiarity with network equipment and technologies (routers, switches, firewalls).",
          "Basic knowledge of network security principles and best practices.",
          "Strong problem-solving and analytical skills.",
          "Good understanding of network troubleshooting techniques.",
          "Effective communication and teamwork abilities.",
          "Ability to learn and adapt quickly to new technologies and tools."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Network Engineer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand network requirements and design efficient and scalable network solutions.",
          "Design, configure, and implement network equipment, including routers, switches, firewalls, and wireless access points.",
          "Ensure network security measures are implemented and maintained, including firewalls, VPNs, and intrusion detection systems.",
          "Monitor and optimize network performance and availability, proactively identifying and resolving issues.",
          "Conduct network capacity planning and assessment to ensure scalability and reliability.",
          "Implement and maintain network documentation, including network diagrams, configurations, and procedures.",
          "Participate in network troubleshooting and problem resolution, including diagnosing and resolving network incidents.",
          "Stay up-to-date with the latest networking technologies, trends, and best practices.",
          "Contribute to the continuous improvement of network engineering processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Network Engineer or similar role, with a strong understanding of network engineering principles and best practices.",
          "Bachelor's degree in computer science, information systems, or a related field (or equivalent work experience).",
          "Solid knowledge of networking protocols and technologies (TCP/IP, DNS, DHCP, routing, switching, VLANs, VPNs, etc.).",
          "Experience with network equipment and technologies, including routers, switches, firewalls, and wireless access points.",
          "Strong understanding of network security principles and best practices.",
          "Proficiency in network troubleshooting and problem resolution.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Experience with network monitoring and performance optimization tools.",
          "Certifications such as CCNA or CCNP are preferred."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Java Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into Java-based solutions.",
          "Assist in the design, development, and testing of Java applications.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Debug and troubleshoot issues, identify root causes, and implement effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest Java development trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Strong understanding of object-oriented programming principles and concepts.",
          "Proficiency in Java programming language.",
          "Familiarity with Java development frameworks (e.g., Spring, Hibernate) is a plus.",
          "Basic knowledge of web technologies (HTML, CSS, JavaScript) is beneficial.",
          "Experience with version control systems, such as Git, is a plus.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Java Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable Java application solutions.",
          "Develop, test, and maintain Java applications, ensuring code quality and adherence to coding standards.",
          "Write clean, efficient, and maintainable code following best practices and design patterns.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Debug and resolve complex technical issues, identifying root causes and implementing effective solutions.",
          "Collaborate with cross-functional teams, including designers, UI/UX specialists, and backend developers, to integrate frontend and backend components.",
          "Stay updated with the latest Java development trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Java Developer or similar role, with a strong understanding of Java programming language and development frameworks (e.g., Spring, Hibernate).",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proficiency in web technologies (HTML, CSS, JavaScript) and frontend frameworks (e.g., React, Angular) is beneficial.",
          "Solid knowledge of database technologies and SQL.",
          "Familiarity with version control systems, such as Git.",
          "Experience with agile software development methodologies.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "PHP Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into PHP-based solutions.",
          "Assist in the design, development, and testing of PHP web applications.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Debug and troubleshoot issues, identify root causes, and implement effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest PHP development trends, frameworks, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Strong understanding of PHP programming language and its fundamentals.",
          "Familiarity with web development technologies (HTML, CSS, JavaScript) and frameworks (e.g., Laravel, Symfony) is a plus.",
          "Experience with MySQL or other database systems.",
          "Basic knowledge of version control systems, such as Git.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "PHP Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable PHP application solutions.",
          "Develop, test, and maintain PHP web applications, ensuring code quality and adherence to coding standards.",
          "Write clean, efficient, and maintainable code following best practices and design patterns.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Debug and resolve complex technical issues, identifying root causes and implementing effective solutions.",
          "Collaborate with cross-functional teams, including designers, UI/UX specialists, and backend developers, to integrate frontend and backend components.",
          "Stay updated with the latest PHP development trends, frameworks, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a PHP Developer or similar role, with a strong understanding of PHP programming language and development frameworks (e.g., Laravel, Symfony).",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proficiency in web development technologies (HTML, CSS, JavaScript) and frontend frameworks (e.g., React, Angular) is beneficial.",
          "Solid knowledge of database technologies and SQL.",
          "Familiarity with version control systems, such as Git.",
          "Experience with agile software development methodologies.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "DevOps Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development and operations teams to understand project requirements and translate them into efficient and scalable DevOps solutions.",
          "Assist in the design, implementation, and management of build and deployment pipelines using continuous integration/continuous deployment (CI/CD) tools.",
          "Participate in configuration management activities using tools like Ansible, Chef, or Puppet.",
          "Support the development and deployment of infrastructure as code using tools like Terraform or CloudFormation.",
          "Assist in automating infrastructure provisioning, monitoring, and scaling using tools like Kubernetes, Docker, or AWS services.",
          "Participate in monitoring and troubleshooting of production environments to ensure high availability and performance."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Basic understanding of software development principles and practices.",
          "Familiarity with scripting languages (e.g., Bash, Python) for automation tasks.",
          "Knowledge of version control systems, such as Git.",
          "Familiarity with Linux/Unix environments and command-line interfaces.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "DevOps Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable DevOps solutions.",
          "Design and implement automated build, deployment, and release processes using continuous integration/continuous deployment (CI/CD) tools.",
          "Configure and manage infrastructure as code using tools like Terraform or CloudFormation.",
          "Implement and maintain configuration management using tools like Ansible, Chef, or Puppet.",
          "Set up and manage containerization platforms using tools like Kubernetes or Docker.",
          "Automate infrastructure provisioning, monitoring, and scaling using cloud services like AWS, Azure, or Google Cloud.",
          "Collaborate with cross-functional teams, including developers, operations, and quality assurance, to ensure seamless integration and delivery.",
          "Monitor and troubleshoot production environments to ensure high availability and performance.",
          "Stay updated with the latest DevOps technologies, tools, and best practices.",
          "Contribute to the continuous improvement of DevOps processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proven experience as a DevOps Developer or similar role, with a strong understanding of DevOps practices and tools.",
          "Proficiency in scripting languages (e.g., Bash, Python) for automation tasks.",
          "Strong knowledge of CI/CD tools like Jenkins, GitLab CI/CD, or CircleCI.",
          "Experience with configuration management tools like Ansible, Chef, or Puppet.",
          "Solid understanding of infrastructure as code using tools like Terraform or CloudFormation.",
          "Experience with containerization platforms like Kubernetes or Docker.",
          "Familiarity with cloud services like AWS, Azure, or Google Cloud.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Cloud Engineer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development and operations teams to understand project requirements and translate them into efficient and scalable cloud-based solutions.",
          "Assist in the design, implementation, and management of cloud infrastructure using services like AWS, Azure, or Google Cloud Platform.",
          "Participate in cloud resource provisioning, configuration, and optimization activities.",
          "Assist in the deployment and maintenance of applications and services in a cloud environment.",
          "Support automation efforts by creating and maintaining infrastructure as code using tools like Terraform or CloudFormation.",
          "Monitor and troubleshoot cloud infrastructure, identifying and resolving issues proactively.",
          "Stay up-to-date with the latest cloud technologies, trends, and best practices.",
          "Contribute to the continuous improvement of cloud engineering processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Basic understanding of cloud computing concepts and services.",
          "Familiarity with at least one major cloud provider, such as AWS, Azure, or Google Cloud Platform.",
          "Basic knowledge of infrastructure as code using tools like Terraform or CloudFormation is a plus.",
          "Strong problem-solving and analytical skills.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Familiarity with scripting languages like Python, Bash, or PowerShell is beneficial.",
          "Knowledge of virtualization technologies and containers (e.g., Docker) is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Cloud Engineer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable cloud-based solutions.",
          "Design, implement, and manage cloud infrastructure using services and technologies from major cloud providers such as AWS, Azure, or Google Cloud Platform.",
          "Provision and configure cloud resources, ensuring optimal performance, scalability, and cost efficiency.",
          "Implement and maintain infrastructure as code using tools like Terraform or CloudFormation.",
          "Deploy and manage applications and services in a cloud environment.",
          "Monitor and troubleshoot cloud infrastructure, proactively identifying and resolving issues.",
          "Implement security best practices and maintain compliance standards in cloud environments.",
          "Collaborate with cross-functional teams, including developers, operations, and security, to ensure seamless integration and delivery.",
          "Stay updated with the latest cloud technologies, trends, and best practices.",
          "Contribute to the continuous improvement of cloud engineering processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Cloud Engineer or similar role, with a strong understanding of cloud computing concepts and services.",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Strong knowledge of at least one major cloud provider, such as AWS, Azure, or Google Cloud Platform.",
          "Experience with infrastructure as code using tools like Terraform or CloudFormation.",
          "Proficiency in scripting and automation using languages like Python, Bash, or PowerShell.",
          "Solid understanding of networking, security, and best practices in a cloud environment.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Relevant certifications, such as AWS Certified Solutions Architect or Azure Certified Engineer, are preferred."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "AWS Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into AWS-based solutions.",
          "Develop and deploy applications on AWS cloud services, ensuring scalability, reliability, and security.",
          "Write clean, efficient, and maintainable code following AWS best practices.",
          "Utilize AWS services such as EC2, Lambda, S3, DynamoDB, API Gateway, and others as needed for application development.",
          "Participate in the integration of applications with AWS services, ensuring seamless functionality and performance.",
          "Assist in database setup and management using AWS database services like RDS or DynamoDB.",
          "Implement and maintain infrastructure as code using AWS CloudFormation or AWS CDK.",
          "Collaborate with cross-functional teams to ensure the successful delivery of AWS-based solutions.",
          "Stay up-to-date with the latest AWS technologies, services, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Basic understanding of cloud computing concepts and AWS services.",
          "Familiarity with at least one programming language, such as Python, Java, or Node.js.",
          "Knowledge of web technologies like HTML, CSS, and JavaScript.",
          "Strong problem-solving and analytical skills.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Familiarity with version control systems, such as Git."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "AWS Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable AWS-based solutions.",
          "Develop and deploy applications on AWS cloud services, ensuring scalability, reliability, and security.",
          "Write clean, efficient, and maintainable code following AWS best practices.",
          "Utilize AWS services such as EC2, Lambda, S3, DynamoDB, API Gateway, and others to architect and develop cloud solutions.",
          "Integrate applications with AWS services, ensuring seamless functionality and optimal performance.",
          "Implement and maintain infrastructure as code using AWS CloudFormation or AWS CDK.",
          "Set up and manage databases using AWS database services like RDS or DynamoDB.",
          "Monitor and troubleshoot AWS-based applications and services, identifying and resolving issues proactively.",
          "Stay up-to-date with the latest AWS technologies, services, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as an AWS Developer or similar role, with a strong understanding of AWS services and cloud development principles.",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proficiency in at least one programming language, such as Python, Java, or Node.js.",
          "Solid knowledge of web technologies like HTML, CSS, and JavaScript.",
          "Strong problem-solving and analytical skills.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment.",
          "Familiarity with version control systems, such as Git.",
          "AWS Certified Developer Associate or other relevant certifications are preferred."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Python Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into Python-based solutions.",
          "Develop, test, and maintain Python applications, ensuring code quality and adherence to coding standards.",
          "Write clean, efficient, and maintainable code following best practices and design patterns.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Debug and troubleshoot issues, identify root causes, and implement effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest Python development trends, libraries, and best practices."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Strong understanding of Python programming language and its fundamentals.",
          "Familiarity with web technologies (HTML, CSS, JavaScript) and frameworks (e.g., Django, Flask) is beneficial.",
          "Experience with database systems and SQL.",
          "Basic knowledge of version control systems, such as Git.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Python Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable Python application solutions.",
          "Develop, test, and maintain Python applications, ensuring code quality and adherence to coding standards.",
          "Write clean, efficient, and maintainable code following best practices and design patterns.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Debug and resolve complex technical issues, identifying root causes and implementing effective solutions.",
          "Collaborate with cross-functional teams, including designers, UI/UX specialists, and backend developers, to integrate frontend and backend components.",
          "Stay updated with the latest Python development trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Python Developer or similar role, with a strong understanding of Python programming language and development frameworks (e.g., Django, Flask).",
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proficiency in web technologies (HTML, CSS, JavaScript) and frontend frameworks (e.g., React, Angular) is beneficial.",
          "Solid knowledge of database technologies and SQL.",
          "Familiarity with version control systems, such as Git.",
          "Experience with agile software development methodologies.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": ".NET Developer (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with the development team to understand project requirements and translate them into .NET-based solutions.",
          "Assist in the design, development, and testing of .NET applications.",
          "Write clean, efficient, and maintainable code following best practices and coding standards.",
          "Participate in code reviews, identify areas for improvement, and provide constructive feedback.",
          "Debug and troubleshoot issues, identify root causes, and implement effective solutions.",
          "Collaborate with cross-functional teams, including designers and backend developers, to ensure seamless integration and functionality.",
          "Stay up-to-date with the latest .NET development trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Actively participate in team meetings, knowledge sharing sessions, and training programs."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, software engineering, or a related field.",
          "Strong understanding of .NET framework and its fundamentals.",
          "Familiarity with C# programming language.",
          "Knowledge of web development technologies (HTML, CSS, JavaScript) and frameworks (e.g., ASP.NET, MVC) is beneficial.",
          "Experience with database systems and SQL.",
          "Basic knowledge of version control systems, such as Git."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": ".NET Developer Associate",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with clients and internal teams to understand project requirements and design efficient and scalable .NET application solutions.",
          "Develop, test, and maintain .NET applications, ensuring code quality and adherence to coding standards.",
          "Write clean, efficient, and maintainable code following best practices and design patterns.",
          "Participate in code reviews, provide constructive feedback, and mentor junior team members.",
          "Debug and resolve complex technical issues, identifying root causes and implementing effective solutions.",
          "Collaborate with cross-functional teams, including designers, UI/UX specialists, and backend developers, to integrate frontend and backend components.",
          "Participate in the full software development lifecycle, including requirements analysis, design, development, testing, deployment, and maintenance.",
          "Stay updated with the latest .NET development trends, libraries, and best practices.",
          "Contribute to the continuous improvement of development processes and methodologies.",
          "Communicate effectively with clients, project stakeholders, and team members, providing regular project updates and addressing any concerns.",
          "Ensure compliance with coding standards, security guidelines, and performance optimization techniques."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in computer science, software engineering, or a related field (or equivalent work experience).",
          "Proven experience as a .NET Developer or similar role, with a strong understanding of .NET framework and development technologies.",
          "Proficiency in C# programming language.",
          "Experience with web development technologies (HTML, CSS, JavaScript) and frameworks (e.g., ASP.NET, MVC).",
          "Solid knowledge of database technologies and SQL.",
          "Familiarity with version control systems, such as Git.",
          "Experience with agile software development methodologies.",
          "Strong problem-solving skills and attention to detail.",
          "Effective communication and collaboration abilities, with the capacity to work well in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Project Management (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Assist project managers in planning and organizing projects, including defining project scope, objectives, and deliverables.",
          "Collaborate with cross-functional teams to gather project requirements and create project plans, schedules, and timelines.",
          "Support project managers in monitoring project progress, identifying risks and issues, and proposing mitigation strategies.",
          "Assist in resource management, including coordinating team members' schedules, tracking their tasks, and ensuring timely completion.",
          "Assist in conducting project meetings, preparing meeting agendas, documenting meeting minutes, and following up on action items.",
          "Support the project team in gathering and analyzing project data, producing reports, and presenting project updates."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in business administration, project management, or a related field.",
          "Strong organizational and time management skills, with the ability to prioritize tasks and meet deadlines.",
          "Excellent verbal and written communication skills.",
          "Proficient in using project management software and tools (e.g., Microsoft Project, Trello, Asana, or Jira).",
          "Familiarity with project management methodologies, such as Agile or Waterfall, is a plus.",
          "Detail-oriented with strong problem-solving and analytical abilities.",
          "Ability to work well in a team environment and collaborate with individuals at various levels.",
          "Strong interpersonal skills, with the ability to build positive relationships with stakeholders.",
          "Proficiency in Microsoft Office applications, including Word, Excel, and PowerPoint."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Project Manager",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Lead and manage the end-to-end project lifecycle, from initiation to closure, ensuring successful project delivery.",
          "Define project scope, objectives, and deliverables in collaboration with clients and stakeholders.",
          "Develop detailed project plans, including timelines, resource allocation, and task assignments.",
          "Monitor project progress, track key milestones, and provide regular project status updates to stakeholders.",
          "Identify and manage project risks, issues, and dependencies, implementing mitigation strategies when necessary.",
          "Effectively communicate project expectations, goals, and requirements to team members and stakeholders.",
          "Coordinate and manage cross-functional teams, ensuring collaboration and effective utilization of resources.",
          "Foster a positive and collaborative team environment, motivating team members to achieve project objectives.",
          "Conduct regular project meetings, including kick-off meetings, status meetings, and retrospective sessions.",
          "Monitor project budgets, ensuring cost control and adherence to financial guidelines.",
          "Provide leadership and guidance to project team members, delegating tasks and providing ongoing support and feedback.",
          "Conduct project post-mortems and capture lessons learned for continuous improvement.",
          "Stay updated with industry best practices and project management methodologies, sharing knowledge with the team.",
          "Collaborate with clients to understand their needs, address concerns, and maintain strong relationships."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Project Manager or similar role, successfully managing complex projects.",
          "Bachelor's degree in business administration, project management, or a related field (or equivalent work experience).",
          "Strong knowledge and application of project management methodologies, such as Agile or Waterfall.",
          "Excellent leadership, organizational, and communication skills.",
          "Ability to effectively manage multiple projects simultaneously.",
          "Proficient in project management software and tools (e.g., Microsoft Project, Jira, or Asana).",
          "Strong problem-solving and decision-making abilities, ability to work well under pressure and meet tight deadlines.",
          "Strong interpersonal skills, with the ability to build positive relationships with clients and team members."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Account Management (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Assist the account management team in building and maintaining strong relationships with clients.",
          "Support in managing client accounts, including handling inquiries, providing product information, and addressing concerns.",
          "Assist in the preparation of client proposals, contracts, and presentations.",
          "Collaborate with internal teams to ensure timely and successful delivery of products or services to clients.",
          "Assist in analyzing client data and generating reports to track key performance metrics.",
          "Participate in client meetings and calls, taking notes and following up on action items.",
          "Assist in identifying upselling or cross-selling opportunities with existing clients.",
          "Conduct market research and competitive analysis to identify trends and opportunities in the industry."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in business administration, marketing, or a related field.",
          "Strong interpersonal and communication skills, both verbal and written.",
          "Excellent organizational and time management skills, with the ability to prioritize tasks.",
          "Detail-oriented with strong analytical and problem-solving abilities.",
          "Proficiency in Microsoft Office applications, particularly Excel, PowerPoint, and Word.",
          "Ability to work well in a team environment and collaborate with individuals at various levels.",
          "Familiarity with CRM systems or sales software is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Account Manager",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Serve as the primary point of contact for assigned clients, building and maintaining strong relationships.",
          "Understand clients' business objectives, challenges, and needs, and provide strategic guidance and solutions to drive their success.",
          "Proactively identify upselling or cross-selling opportunities to expand business with existing clients.",
          "Collaborate with internal teams to ensure the timely delivery of products or services to clients, coordinating project timelines and resources.",
          "Conduct regular client meetings to review performance, address concerns, and gather feedback.",
          "Prepare and present client reports, providing insights and recommendations for improvement.",
          "Analyze client data and market trends to identify growth opportunities and develop account strategies.",
          "Develop account plans and set measurable goals to track client success and achieve revenue targets.",
          "Stay updated with industry trends, competitors' activities, and market conditions.",
          "Work closely with the sales team to identify and pursue new business opportunities within existing accounts.",
          "Negotiate contract terms and renewals, ensuring favorable outcomes for both the client and the company.",
          "Resolve client issues and escalate complex problems to the appropriate internal teams for resolution.",
          "Collaborate with the marketing team to develop targeted campaigns and initiatives for client engagement and retention.",
          "Provide leadership and guidance to account management team members, fostering a positive and collaborative work environment."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in business administration, marketing, or a related field (or equivalent work experience).",
          "Proven experience as an Account Manager or similar role, successfully managing client relationships and driving revenue growth.",
          "Strong interpersonal and communication skills, with the ability to build trust and rapport with clients.",
          "Excellent negotiation and problem-solving abilities.",
          "Strong analytical and strategic thinking skills, with the ability to analyze data and make data-driven decisions.",
          "Ability to multitask, prioritize, and manage multiple client accounts simultaneously.",
          "Proficiency in CRM systems and sales software.",
          "Strong business acumen and understanding of industry trends and dynamics."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Human Resource (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Assist in the recruitment and selection process by posting job ads, screening resumes, and scheduling interviews.",
          "Support the onboarding process for new hires, including preparing offer letters, coordinating orientation sessions, and organizing necessary documentation.",
          "Assist in maintaining employee records and databases, ensuring accuracy and confidentiality.",
          "Help with employee engagement initiatives, such as organizing team-building activities, employee recognition programs, and wellness initiatives.",
          "Assist in HR policy development and updating employee handbooks and manuals.",
          "Support the performance management process, including tracking performance reviews, goal-setting, and providing administrative assistance.",
          "Help in coordinating training and development programs, including scheduling training sessions and tracking attendance."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in Human Resources, Business Administration, or a related field.",
          "Strong organizational and time management skills, with the ability to prioritize tasks and meet deadlines.",
          "Excellent attention to detail and accuracy in handling confidential information.",
          "Strong interpersonal and communication skills, both written and verbal.",
          "Proficiency in Microsoft Office applications, particularly Excel, Word, and PowerPoint.",
          "Ability to work well in a team environment and collaborate effectively.",
          "Basic knowledge of HR principles, policies, and employment laws is preferred."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Human Resource Manager",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Develop and implement HR strategies, policies, and procedures aligned with the company's goals and objectives.",
          "Oversee the full recruitment and selection process, including job postings, candidate screening, interviews, and offers of employment.",
          "Lead the onboarding process for new hires, ensuring a smooth and positive transition into the organization.",
          "Provide guidance and support to managers and employees on employee relations matters, including conflict resolution, performance improvement plans, and disciplinary actions.",
          "Manage the performance management process, including goal setting, performance appraisals, and development plans.",
          "Plan and execute training and development initiatives to enhance employee skills and capabilities.",
          "Collaborate with department managers to identify talent needs, succession planning, and workforce planning.",
          "Stay updated with employment laws and regulations, ensuring compliance with legal requirements.",
          "Manage compensation and benefits programs, including salary administration, benefits administration, and annual compensation reviews.",
          "Develop and implement employee engagement programs to foster a positive and inclusive work environment.",
          "Conduct regular HR metrics analysis to identify trends and make data-driven decisions.",
          "Handle employee grievances and mediate conflicts, promoting a culture of fairness and respect.",
          "Manage employee offboarding processes, including exit interviews and necessary documentation.",
          "Stay updated with HR trends, best practices, and emerging technologies, and propose improvements to HR processes and systems.",
          "Lead and manage the HR team, providing guidance, mentorship, and performance feedback."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Bachelor's degree in Human Resources, Business Administration, or a related field. Master's degree is a plus.",
          "Proven experience as an HR Manager or similar role, with a strong understanding of HR principles and practices.",
          "Solid knowledge of employment laws and regulations.",
          "Strong interpersonal and communication skills, with the ability to build positive relationships at all levels of the organization.",
          "Excellent leadership and people management abilities.",
          "Ability to work in a fast-paced, dynamic environment and manage multiple priorities.",
          "Strong problem-solving and decision-making skills.",
          "Proficiency in HRIS and other HR-related software and tools.",
          "HR certification (e.g., SHRM-CP or PHR) is preferred."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  },
  {
    "profile": "Data Scientist (Intern)",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Assist in collecting, cleaning, and preprocessing large datasets for analysis.",
          "Collaborate with the data science team to develop and implement machine learning models and algorithms.",
          "Conduct data analysis to extract meaningful insights and patterns from structured and unstructured data.",
          "Assist in designing and implementing data visualizations and dashboards to communicate findings effectively.",
          "Support the development and maintenance of data pipelines and workflows.",
          "Participate in model evaluation and performance optimization.",
          "Assist in researching and implementing state-of-the-art data science techniques and methodologies."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Pursuing a degree in computer science, data science, statistics, or a related field.",
          "Strong analytical and problem-solving skills, with a passion for data and its applications.",
          "Proficiency in programming languages such as Python or R.",
          "Familiarity with data analysis libraries and frameworks (e.g., Pandas, NumPy, scikit-learn).",
          "Basic knowledge of machine learning algorithms and techniques.",
          "Experience with data visualization tools (e.g., Tableau, matplotlib, seaborn) is a plus.",
          "Knowledge of SQL and database querying.",
          "Strong written and verbal communication skills.",
          "Ability to work independently and in a team environment."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": [
          "Certificate after successful completion of internship",
          "Letter of recommendation",
          "Stipend (performance-based)",
          "Flexible working hours"
        ]
      },
      { "title": "Duration", "type": "text", "content": "3 months" },
      { "title": "Timings", "type": "text", "content": "4 hours; 8 hours on weekend" },
      { "title": "Stipend", "type": "text", "content": "Performance-Based" }
    ]
  },
  {
    "profile": "Data Scientist",
    "sections": [
      {
        "title": "Job Description",
        "type": "list",
        "content": [
          "Collaborate with stakeholders to understand business requirements and translate them into data-driven solutions.",
          "Collect, preprocess, and analyze large and complex datasets using statistical techniques and machine learning algorithms.",
          "Develop and implement predictive models and algorithms to solve business problems and generate actionable insights.",
          "Perform exploratory data analysis and data visualization to uncover patterns, trends, and correlations.",
          "Conduct statistical analysis and hypothesis testing to validate models and make data-driven recommendations.",
          "Interpret and communicate the results of data analyses to both technical and non-technical stakeholders.",
          "Collaborate with cross-functional teams, including data engineers and software developers, to implement and deploy data solutions.",
          "Stay updated with the latest developments in data science, machine learning, and statistical modeling techniques.",
          "Mentor and provide guidance to junior data scientists, fostering a collaborative and knowledge-sharing environment.",
          "Contribute to the continuous improvement of data science methodologies and processes within the organization.",
          "Ensure compliance with data privacy and security regulations during all stages of data analysis and model development."
        ]
      },
      {
        "title": "Requirements",
        "type": "list",
        "content": [
          "Minimum 2 years of experience as a Data Scientist or similar role, with a strong track record of delivering successful data-driven solutions.",
          "Master's or Ph.D. degree in a quantitative field such as computer science, statistics, mathematics, or a related discipline.",
          "Strong knowledge and hands-on experience in data analysis, statistical modeling, and machine learning techniques.",
          "Proficiency in programming languages such as Python or R, and familiarity with relevant libraries and frameworks.",
          "Experience with data visualization tools and techniques to effectively communicate complex data insights.",
          "Strong problem-solving and analytical skills, with the ability to think critically and drive innovative solutions.",
          "Excellent communication and presentation skills, with the ability to convey complex ideas to both technical and non-technical stakeholders.",
          "Experience working with large datasets, structured and unstructured data, and data manipulation techniques.",
          "Familiarity with big data technologies such as Hadoop, Spark, or NoSQL databases is a plus."
        ]
      },
      {
        "title": "Perks & Benefits",
        "type": "list",
        "content": []
      },
      { "title": "Duration", "type": "text", "content": "" },
      { "title": "Timings", "type": "text", "content": "" },
      { "title": "Stipend", "type": "text", "content": "" }
    ]
  }

  ];